import { useLocation } from "react-router-dom";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { ErrorMessage, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { renderSuccessMessage } from "src/assets/functions";
import { resetPassword } from "src/api";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useState } from "react";

const ResetPasswordPage = () => {

    const navigate = useNavigate();

    const [visible, setVisible] = useState(false);

    const [visible1, setVisible1] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    const signInSchema = yup.object().shape({
        password: yup
            .string()
            .required("Please enter your new password")
            .min(6, "Password must be at least 6 characters"),
        confirmPassword: yup
            .string()
            .oneOf([yup.ref("password"), null], "Passwords must match")
            .required("Please confirm your new password"),
    });
    const initialValues = {
        password: "",
        confirmPassword: "",
    };


    const { mutate, isLoading } = useMutation(resetPassword, {
        onSuccess: (data) => {
            renderSuccessMessage(data?.message);
            navigate(`/login`);
        },

    });

    return (

        <div>
            <div className="container">
                <Formik
                    initialValues={initialValues}
                    validationSchema={signInSchema}
                    onSubmit={(values) => {
                        mutate({
                            ...values,
                            token, // include the token in the payload
                        });
                    }}
                >
                    {({
                        values,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                    }) => (
                        <div className="min-h-screen flex items-center justify-center px-4">
                            <form onSubmit={handleSubmit} className="w-full max-w-xl bg-white shadow-md p-8 rounded-md">
                                <div className="enternewcredentials">
                                    <div className="has-pwd-icon">
                                        <input
                                            placeholder="Enter New Password"
                                            name="password"
                                            onChange={handleChange}
                                            value={values.password}
                                            className="w-full border p-3 rounded-md mt-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                                            type={visible ? "text" : "password"}
                                        />
                                        {visible ? (
                                            <BsEye
                                                className="view-pwd"
                                                size={20}
                                                onClick={() =>
                                                    setVisible(
                                                        (prevState) =>
                                                            !prevState
                                                    )
                                                }
                                            />
                                        ) : (
                                            <BsEyeSlash
                                                className="view-pwd"
                                                size={20}
                                                onClick={() =>
                                                    setVisible(
                                                        (prevState) =>
                                                            !prevState
                                                    )
                                                }
                                            />
                                        )}
                                        <ErrorMessage
                                            name="password"
                                            component="div"
                                            className="text-red-500  error-message"
                                        />
                                    </div>
                                    <div className="has-pwd-icon">
                                        <input
                                            type={visible1 ? "text" : "password"}
                                            placeholder="Confirm New Password"
                                            name="confirmPassword"
                                            onChange={handleChange}
                                            value={values.confirmPassword}
                                            className="w-full border p-3 rounded-md mt-[35px] focus:outline-none focus:ring-2 focus:ring-green-500"
                                        />
                                        {visible1 ? (
                                            <BsEye
                                                className="view-pwd"
                                                size={20}
                                                onClick={() =>
                                                    setVisible1(
                                                        (prevState) =>
                                                            !prevState
                                                    )
                                                }
                                            />
                                        ) : (
                                            <BsEyeSlash
                                                className="view-pwd"
                                                size={20}
                                                onClick={() =>
                                                    setVisible1(
                                                        (prevState) =>
                                                            !prevState
                                                    )
                                                }
                                            />
                                        )}
                                        <ErrorMessage
                                            name="confirmPassword"
                                            component="div"
                                            className="text-red-500  error-message"
                                        />
                                    </div>
                                    <button className="w-full text-white p-3 rounded-md transition login-up-btn mt-[35px]">
                                        Reset Password
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
